import { tryParseInt } from './number';

/**
 * Konfiguracja aplikacji
 *
 * @export
 * @class Config
 */
export class Config {
  /**
   * URL api GraphQL
   *
   * @type {string}
   * @memberof Config
   */
  public graphQLURL: string;

  /**
   * URL api websocket
   *
   * @type {string}
   * @memberof Config
   */
  public websocketURL: string;

  /**
   * URL api medii
   *
   * @type {string}
   * @memberof Config
   */
  public mediaURL: string;

  /**
   * Url renderowania widoków
   *
   * @type {string}
   * @memberof Config
   */
  public renderURL: string;

  /**
   * URL generowania CSV
   *
   * @type {string}
   * @memberof Config
   */
  public csvURL: string;

  /**
   * URL logowania przez SSO
   *
   * @type {string}
   * @memberof Config
   */
  public ssoLoginURL: string;

  /**
   * URL wylogowania przez SSO
   *
   * @type {string}
   * @memberof Config
   */
  public ssoLogoutURL: string;

  /**
   * URL podpisu przez EPUAP
   *
   * @type {string}
   * @memberof Config
   */
  public epuapURL: string;

  /**
   * Wysyłanie wielu plików w jednym żądaniu
   *
   * @type {boolean}
   * @memberof Config
   */
  public uploadMultiple: boolean;

  /**
   * Nazwa ciastka z tokenem
   *
   * @type {string}
   * @memberof Config
   */
  public tokenCookie: string;

  /**
   * Początkowy rok aplikacji
   *
   * @type {number}
   * @memberof Config
   */
  public startYear: number;

  /**
   * Pole na token w formularzu POST
   *
   * @type {string}
   * @memberof Config
   */
  public tokenFormField: string;

  /**
   * URL do teryt API
   *
   * @type {string}
   * @memberof Config
   */
  public terytUrl: string;

  /**
   * Nazwa serwisu logowania
   *
   * @type {string}
   * @memberof Config
   */
  public logServiceName: string;

  /**
   * Url serwera logowania
   *
   * @type {string}
   * @memberof Config
   */
  public logServerUrl: string;

  /**
   * Wersja serwisu
   *
   * @type {string}
   * @memberof Config
   */
  public serviceVersion: string;

  /**
   * Wyłączone logowanie
   *
   * @type {boolean}
   * @memberof Config
   */
  public loginDisabled: boolean;

  /**
   * Czy aktywna integracja z MDOK
   *
   * @type {boolean}
   * @memberof Config
   */
  public mdokEnabled: boolean;

  /**
   * Procedura aplikacji
   *
   * @type {string}
   * @memberof Config
   */
  public procedure: string;

  /**
   * Ile minut przed końcem ważności tokenu zapytać API o nowy token
   *
   * @type {number}
   * @memberof AuthConfig
   */
  public jwtTimeToRefresh: number;

  constructor() {
    this.graphQLURL = (process.env.VUE_APP_API_URL as string) + 'graphql';
    this.websocketURL = (process.env.VUE_APP_API_URL as string).replace('http', 'ws');
    const regexp = /(?:wss?:)?\/\/[^\/]+\/?(.*)?/;
    const match = regexp.exec(this.websocketURL);
    if (match && match[1]) {
      this.websocketURL = this.websocketURL.replace(match[1], '');
    }
    this.mediaURL = (process.env.VUE_APP_API_URL as string) + 'media';
    this.renderURL = (process.env.VUE_APP_API_URL as string) + 'render';
    this.csvURL = (process.env.VUE_APP_API_URL as string) + 'csv';
    this.ssoLoginURL = (process.env.VUE_APP_API_URL as string) + 'sso/login';
    this.ssoLogoutURL = (process.env.VUE_APP_API_URL as string) + 'sso/logout';
    this.epuapURL = (process.env.VUE_APP_API_URL as string) + 'epuap';
    this.terytUrl = process.env.VUE_APP_TERYT_URL as string;
    this.uploadMultiple = false;
    this.tokenCookie = process.env.VUE_APP_TOKEN_COOKIE as string;
    this.startYear = tryParseInt(process.env.VUE_APP_START_YEAR) || 2019;
    this.tokenFormField = process.env.VUE_APP_TOKEN_FORM_FIELD as string;
    this.logServiceName = process.env.LOGSTASH_NAME as string;
    this.logServerUrl = process.env.VUE_APP_LOGS_SERVER as string;
    this.serviceVersion = process.env.PACKAGE_VERSION as string;
    this.loginDisabled = process.env.VUE_APP_LOGIN_DISABLED === 'true';
    this.mdokEnabled = process.env.VUE_APP_MDOK_ENABLED === 'true';
    this.procedure = process.env.VUE_APP_PROCEDURE || 'stypendia';
    this.jwtTimeToRefresh = tryParseInt(process.env.VUE_APP_JWT_TIME_TO_REFRESH, 6) as number;
  }
}

export const config = new Config();
